import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var StartupInfoMixins = function (_super) {
  __extends(StartupInfoMixins, _super);

  function StartupInfoMixins() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  StartupInfoMixins.prototype.updateSubjectStatus = function (callback) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.queryStartupInfo()];

          case 1:
            data = _a.sent();

            if (data) {
              typeof callback === 'function' && callback(data);
            }

            return [2];
        }
      });
    });
  };

  StartupInfoMixins.prototype.queryStartupInfo = function () {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.certification.queryStartupInfo()];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              return [2, res.data];
            } else {
              return [2, null];
            }

            return [2];
        }
      });
    });
  };

  StartupInfoMixins.prototype.queryAccountCodeStartupInfo = function (params) {
    return __awaiter(this, void 0, void 0, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.certification.queryAccountCodeStartupInfo(params)];

          case 1:
            res = _a.sent();
            return [2, res.data];
        }
      });
    });
  };

  StartupInfoMixins = __decorate([Component], StartupInfoMixins);
  return StartupInfoMixins;
}(Vue);

export default StartupInfoMixins;